import { render } from "./혈당_결과.vue?vue&type=template&id=19555daa"
import script from "./혈당_결과.vue?vue&type=script&lang=js"
export * from "./혈당_결과.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__